import React from 'react';
import PropTypes  from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Select from 'fuse-ui/components/Select';
import { buildDateOptions } from '../utils/datepicker-utils';

const styles = theme => ( {
    selectInput: {
        marginBottom: theme.spacing.unit * 2
    }
} );

const CanvasSettingsTabGeneral = ( { classes, canvasParams, domainGroups, handleOptionChange } ) => {
    const groupOptions = domainGroups.map( group => ( { label: group.name, value: group.id } ) );
    const dateOptions = buildDateOptions( 'basic' );

    const selectedGroup = groupOptions.find( ( group ) => group.value === canvasParams.domainGroupId );
    const selectedDateOption = dateOptions.find( ( option ) => option.value === canvasParams.previousDays );

    return (
        <>
            <Select
                className={classes.selectInput}
                data-automation-id="canvas-settings-domain-group-selector"
                options={groupOptions}
                onChange={handleOptionChange( 'domainGroupId' )}
                value={selectedGroup}
                placeholder="Select a domain group"
                label="Domain Group"
            />
            <Select
                className={classes.selectInput}
                data-automation-id="canvas-settings-date-range-selector"
                onChange={handleOptionChange( 'previousDays' )}
                options={dateOptions}
                value={selectedDateOption}
                placeholder="Select a date range"
                label="Date Range"
            />
        </>
    );
};

CanvasSettingsTabGeneral.propTypes = {
    canvasParams: PropTypes.object.isRequired,
    classes: PropTypes.object,
    domainGroups: PropTypes.array,
    handleOptionChange: PropTypes.func.isRequired,
};

CanvasSettingsTabGeneral.defaultProps = {
    domainsGroups: [],
};


export default withStyles( styles )( CanvasSettingsTabGeneral );
